/**
 * Counter feature for carousel
 * Displays current slide / total slides
 */

/**
 * Setup counter feature
 * @param {CarouselComponent} carousel - Carousel component instance
 * @param {Record<string, any>} options - The carousel's options
 */
export function setupCounter(carousel, options) {
  const slider = carousel.swiperInstance;
  if (!slider) return;

  // Respect explicit disabling: only attach when counter option is present and truthy
  if (!Object.prototype.hasOwnProperty.call(options || {}, "counter")) return;
  if (!options.counter) {
    const maybeEl = /** @type {HTMLElement | null} */ (carousel.querySelector('[ref="counter"]'));
    if (maybeEl) maybeEl.classList.add("hidden");
    return;
  }

  /** @type {HTMLElement | null} */
  const counterEl =
    options?.counter?.el instanceof HTMLElement
      ? options.counter.el
      : /** @type {HTMLElement | null} */ (carousel.querySelector('[ref="counter"]'));
  if (!counterEl) return;

  // Ensure visible when enabled
  counterEl.classList.remove("hidden");

  const format =
    (options?.counter && typeof options.counter.format === "string" ? options.counter.format : carousel.counterFormat) ||
    "{current} / {total}";

  const render = () => {
    const total = slider.slides.length;
    // At the end the last slide counts as the current one, though the track starts at an earlier one
    const current = slider.isEnd && !slider.isBeginning ? total : slider.activeIndex + 1;
    counterEl.textContent = format.replace("{current}", String(current)).replace("{total}", String(total));
  };

  render();
  slider.on("slideChange slidesLengthChange update resize reachEnd fromEdge", render);
}
